import React from 'react';
import Hero from '../components/home/Hero';
import WelcomeMessage from '../components/home/WelcomeMessage';
import OverviewSections from '../components/home/OverviewSections';
import NewsTicker from '../components/home/NewsTicker';
import VideoSection from '../components/home/VideoSection';
import Button from '../components/ui/Button';
import Card from '../components/ui/Card';
import OptimizedImage from '../components/ui/OptimizedImage';
import { ArrowRightIcon, CalendarIcon, GraduationCapIcon, TrophyIcon, UsersIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Home = () => {
  return <div className="min-h-screen bg-white" data-id="element-3653">
      <Hero data-id="element-3654" />
      <NewsTicker data-id="element-3655" />
      <WelcomeMessage data-id="element-3656" />
      <OverviewSections data-id="element-3657" />
      <VideoSection data-id="element-3658" />

      {/* Recent News & Events Section */}
      <section className="py-12 md:py-16 bg-gray-50" data-id="element-3659">
        <div className="container mx-auto px-4" data-id="element-3660">
          <div className="text-center mb-10 md:mb-12" data-id="element-3661">
            <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-3" data-id="element-3662">
              Latest News & Upcoming Events
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3663"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm md:text-base px-4" data-id="element-3664">
              Stay updated with the latest happenings at Isonyin Grammar School
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-id="element-3665">
            <Card hover padding="none" className="overflow-hidden" data-id="element-3666">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/xtrakyEwXvgXDeA5fP3DPg/WhatsApp_Image_2025-08-14_at_15.45.38_%284%29.jpg" alt="Modern classroom facilities" className="w-full" aspectRatio="16/9" data-id="element-3667" />
              <div className="p-5 md:p-6" data-id="element-3668">
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-3669">
                  <CalendarIcon className="h-4 w-4 mr-2" data-id="element-3670" />
                  January 15, 2025
                </div>
                <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-3 hover:text-blue-700 transition-colors" data-id="element-3671">
                  <Link to="/news/waec-results" data-id="element-3672">
                    Outstanding WAEC Results for Class of 2024
                  </Link>
                </h3>
                <p className="text-gray-700 mb-4 text-sm md:text-base" data-id="element-3673">
                  Our graduating class has achieved exceptional results with a
                  95% distinction rate...
                </p>
                <Link to="/news/waec-results" className="inline-flex items-center text-blue-700 font-medium hover:text-blue-900 transition-colors text-sm md:text-base" data-id="element-3674">
                  Read More <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-3675" />
                </Link>
              </div>
            </Card>
            <Card hover padding="none" className="overflow-hidden" data-id="element-3676">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg" alt="Student in uniform" className="w-full" aspectRatio="16/9" data-id="element-3677" />
              <div className="p-5 md:p-6" data-id="element-3678">
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-3679">
                  <CalendarIcon className="h-4 w-4 mr-2" data-id="element-3680" />
                  January 10, 2025
                </div>
                <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-3 hover:text-blue-700 transition-colors" data-id="element-3681">
                  <Link to="/news/science-competition" data-id="element-3682">
                    Science Club Wins Regional Competition
                  </Link>
                </h3>
                <p className="text-gray-700 mb-4 text-sm md:text-base" data-id="element-3683">
                  Our Science Club emerged victorious at the Regional Science
                  Competition...
                </p>
                <Link to="/news/science-competition" className="inline-flex items-center text-blue-700 font-medium hover:text-blue-900 transition-colors text-sm md:text-base" data-id="element-3684">
                  Read More <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-3685" />
                </Link>
              </div>
            </Card>
            <Card hover padding="none" className="overflow-hidden" data-id="element-3686">
              <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/jdfoyTCXLviMyjmi5MDX1X/WhatsApp_Image_2025-10-24_at_11.30.13.jpg" alt="School campus" className="w-full" aspectRatio="16/9" data-id="element-3687" />
              <div className="p-5 md:p-6" data-id="element-3688">
                <div className="flex items-center text-sm text-gray-500 mb-3" data-id="element-3689">
                  <CalendarIcon className="h-4 w-4 mr-2" data-id="element-3690" />
                  March 10, 2025
                </div>
                <h3 className="text-lg md:text-xl font-bold text-blue-900 mb-3 hover:text-blue-700 transition-colors" data-id="element-3691">
                  <Link to="/events/sports-competition" data-id="element-3692">
                    Annual Inter-House Sports Competition
                  </Link>
                </h3>
                <p className="text-gray-700 mb-4 text-sm md:text-base" data-id="element-3693">
                  Join us for our annual sports competition featuring track
                  events and team sports...
                </p>
                <Link to="/events/sports-competition" className="inline-flex items-center text-blue-700 font-medium hover:text-blue-900 transition-colors text-sm md:text-base" data-id="element-3694">
                  View Details <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-3695" />
                </Link>
              </div>
            </Card>
          </div>
          <div className="text-center mt-8 md:mt-10" data-id="element-3696">
            <Button href="/news" variant="secondary" icon={<ArrowRightIcon data-id="element-3698" />} iconPosition="right" data-id="element-3697">
              View All News & Events
            </Button>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-12 md:py-16 bg-white" data-id="element-3699">
        <div className="container mx-auto px-4" data-id="element-3700">
          <div className="text-center mb-10 md:mb-12" data-id="element-3701">
            <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-3" data-id="element-3702">
              What Our Community Says
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3703"></div>
            <p className="mt-4 text-gray-600 max-w-2xl mx-auto text-sm md:text-base px-4" data-id="element-3704">
              Hear from our students, parents, and alumni
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-3705">
            <div className="bg-gray-50 p-5 md:p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-3706">
              <div className="flex items-center mb-4" data-id="element-3707">
                <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/1qDmtoMp7nL55BBaiUBMby/WhatsApp_Image_2025-11-07_at_10.09.21.jpg" alt="Principal" className="w-12 h-12 rounded-full mr-4" objectFit="cover" data-id="element-3708" />
                <div data-id="element-3709">
                  <h4 className="font-bold text-blue-900 text-sm md:text-base" data-id="element-3710">
                    Lamidi Yakubu Olorunyomi
                  </h4>
                  <p className="text-xs md:text-sm text-gray-500" data-id="element-3711">Principal</p>
                </div>
              </div>
              <p className="text-gray-700 italic text-sm md:text-base" data-id="element-3712">
                "At Isonyin Grammar School, we nurture character, build
                confidence, and prepare our students to become leaders."
              </p>
            </div>
            <div className="bg-gray-50 p-5 md:p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-3713">
              <div className="flex items-center mb-4" data-id="element-3714">
                <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/8M2i6Lt61u8AiKMZqhL6Xz/WhatsApp_Image_2025-10-24_at_10.01.22.jpg" alt="Alumni" className="w-12 h-12 rounded-full mr-4" objectFit="cover" data-id="element-3715" />
                <div data-id="element-3716">
                  <h4 className="font-bold text-blue-900 text-sm md:text-base" data-id="element-3717">
                    Dr. Oluwasegun Adeyemi
                  </h4>
                  <p className="text-xs md:text-sm text-gray-500" data-id="element-3718">
                    Alumni, Class of 2000
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic text-sm md:text-base" data-id="element-3719">
                "My foundation at IGS prepared me for success in medical school
                and beyond as a surgeon."
              </p>
            </div>
            <div className="bg-gray-50 p-5 md:p-6 rounded-lg border border-gray-100 shadow-sm hover:shadow-md transition-shadow" data-id="element-3720">
              <div className="flex items-center mb-4" data-id="element-3721">
                <OptimizedImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/tXB2gESgQyPW5hZWnwiFvU/WhatsApp_Image_2025-08-08_at_06.35.51_%281%29.jpg" alt="Student" className="w-12 h-12 rounded-full mr-4" objectFit="cover" data-id="element-3722" />
                <div data-id="element-3723">
                  <h4 className="font-bold text-blue-900 text-sm md:text-base" data-id="element-3724">
                    Chioma Nwosu
                  </h4>
                  <p className="text-xs md:text-sm text-gray-500" data-id="element-3725">
                    Current Student, SS3
                  </p>
                </div>
              </div>
              <p className="text-gray-700 italic text-sm md:text-base" data-id="element-3726">
                "The opportunities at IGS are incredible. The teachers genuinely
                care about our success."
              </p>
            </div>
          </div>
          <div className="text-center mt-6 md:mt-8" data-id="element-3727">
            <Button href="/testimonials" variant="text" icon={<ArrowRightIcon data-id="element-3729" />} iconPosition="right" data-id="element-3728">
              Read More Testimonials
            </Button>
          </div>
        </div>
      </section>

      {/* School Stats Section */}
      <section className="py-16 md:py-20 bg-blue-900 text-white relative overflow-hidden" data-id="element-3730">
        <div className="absolute inset-0 bg-blue-900 opacity-90 z-0" data-id="element-3731"></div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-3732">
          <div className="text-center mb-10 md:mb-12" data-id="element-3733">
            <h2 className="text-2xl md:text-3xl font-bold mb-3" data-id="element-3734">
              Our Impact in Numbers
            </h2>
            <div className="w-24 h-1 bg-yellow-500 mx-auto" data-id="element-3735"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-8 text-center mb-12" data-id="element-3736">
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50 transform transition-transform hover:scale-105" data-id="element-3737">
              <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-3738">
                <CalendarIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-3739" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2" data-id="element-3740">
                1956
              </div>
              <p className="text-sm md:text-lg" data-id="element-3741">Established</p>
            </div>
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50 transform transition-transform hover:scale-105" data-id="element-3742">
              <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-3743">
                <UsersIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-3744" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2" data-id="element-3745">
                15,000+
              </div>
              <p className="text-sm md:text-lg" data-id="element-3746">Alumni Worldwide</p>
            </div>
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50 transform transition-transform hover:scale-105" data-id="element-3747">
              <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-3748">
                <GraduationCapIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-3749" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2" data-id="element-3750">
                95%
              </div>
              <p className="text-sm md:text-lg" data-id="element-3751">WAEC Pass Rate</p>
            </div>
            <div className="bg-blue-800/50 p-4 md:p-6 rounded-lg backdrop-blur-sm border border-blue-700/50 transform transition-transform hover:scale-105" data-id="element-3752">
              <div className="inline-block p-3 md:p-4 rounded-full bg-yellow-500/20 mb-3 md:mb-4" data-id="element-3753">
                <TrophyIcon className="h-6 w-6 md:h-8 md:w-8 text-yellow-400" data-id="element-3754" />
              </div>
              <div className="text-3xl md:text-4xl font-bold text-yellow-400 mb-2" data-id="element-3755">
                68+
              </div>
              <p className="text-sm md:text-lg" data-id="element-3756">Years of Excellence</p>
            </div>
          </div>
          {/* Awards Showcase */}
          <div className="max-w-4xl mx-auto" data-id="element-3757">
            <div className="bg-white/10 backdrop-blur-sm p-6 md:p-8 rounded-lg border border-white/20" data-id="element-3758">
              <h3 className="text-xl md:text-2xl font-bold text-center mb-6" data-id="element-3759">
                Recent Achievements
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-3760">
                <div className="flex items-center space-x-4" data-id="element-3761">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/izoRqPZv7uCHZWbnJ1rXVJ/WhatsApp_Image_2025-10-24_at_13.20.17_%282%29.jpg" alt="Science competition trophy" className="w-24 h-24 object-contain rounded" data-id="element-3762" />
                  <div data-id="element-3763">
                    <h4 className="font-bold text-yellow-400 mb-1" data-id="element-3764">
                      Science Excellence
                    </h4>
                    <p className="text-sm text-white/90" data-id="element-3765">
                      Winner of Royal Camel Area Science Club Schools Essay
                      Competition
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-4" data-id="element-3766">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hLZSXSdtdK6mk3VNd7a3xR/WhatsApp_Image_2025-10-24_at_10.01.24.jpg" alt="Academic trophies" className="w-24 h-24 object-contain rounded" data-id="element-3767" />
                  <div data-id="element-3768">
                    <h4 className="font-bold text-yellow-400 mb-1" data-id="element-3769">
                      Academic Honors
                    </h4>
                    <p className="text-sm text-white/90" data-id="element-3770">
                      Multiple awards in inter-school academic competitions
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-20 bg-gradient-to-r from-yellow-500 to-yellow-400" data-id="element-3771">
        <div className="container mx-auto px-4 text-center" data-id="element-3772">
          <div className="max-w-3xl mx-auto" data-id="element-3773">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-blue-900 mb-4 md:mb-6" data-id="element-3774">
              Ready to Join Our Community?
            </h2>
            <p className="text-base md:text-lg text-blue-900 mb-6 md:mb-8 leading-relaxed px-4" data-id="element-3775">
              Take the first step towards a brighter future at Isonyin Grammar
              School.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-3776">
              <Button href="/admissions" variant="secondary" size="lg" icon={<ArrowRightIcon data-id="element-3778" />} iconPosition="right" animation="scale" data-id="element-3777">
                Apply for Admission
              </Button>
              <Button href="/virtual-tour" variant="outline" size="lg" className="border-blue-900 text-blue-900 hover:bg-blue-900/10" data-id="element-3779">
                Take a Virtual Tour
              </Button>
              <Button href="/contact" variant="outline" size="lg" className="border-blue-900 text-blue-900 hover:bg-blue-900/10" data-id="element-3780">
                Contact Us
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};
export default Home;